import {useEffect} from 'react'

/**
 * @return {null}
 */
function LogoutPage() {

  useEffect(() => {
    const token = localStorage.getItem('jwt-token')
    // logout front
    localStorage.removeItem('jwt-token')
    // trigger single logout
    if(token) {
      window.location.assign(`/api/auth/logout?token=${token}`)
    }
  }, [])

  return null
}

export default LogoutPage
